// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"298f068a","142":"240264c3","239":"0c5402f2","407":"80d4440b","510":"d00d7e23"}[chunkId] + ".chunk.js";
};